<div class="text-center pt-5">
    <span>Vous avez été déconnecté.</span>
</div>

<div class="text-center mt-3">
    <button mat-raised-button color="accent" [routerLink]="['/login']">Se reconnecter</button>
</div>
